export default __webpack_public_path__ + "static/media/prop1.b277bbe3.png";